<template>
  <div class="image-container">
    <!-- Your image -->
    <img
        src="../../public/img/sign.png"
        alt="Sign Image"
        class="sign-image"
        :class="{ 'hover-on-load': hoveredOnLoad }"
    />
    <!-- Text below the image -->
    <p class="below-text">Please select an agent number</p>
  </div>
</template>

<script>
export default {
  name: 'SignImageComponent',
  data() {
    return {
      hoveredOnLoad: false,
    };
  },
  mounted() {
    // Trigger hover effect when the page loads
    setTimeout(() => {
      this.hoveredOnLoad = true;
    }, 500); // Wait for 0.5s before triggering the hover effect

    // Remove hover effect after a short time
    setTimeout(() => {
      this.hoveredOnLoad = false;
    }, 1500); // Return to original state after 1 second
  },
};
</script>

<style scoped>
.image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full screen height to center vertically */
  padding: 0 20px; /* Add padding for small screens */
}

.sign-image {
  width: 40vw; /* Use viewport width for responsiveness */
  max-width: 300px; /* Maximum width for larger screens */
  height: auto;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); /* Adding shadow behind the image */
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
}

/* Hover effect */
.sign-image:hover,
.sign-image.hover-on-load {
  transform: scale(1.1); /* Slight zoom effect on hover */
}

.below-text {
  margin-top: 20px; /* Space between image and text */
  font-size: 1.5rem;
  color: #333; /* Text color */
  text-align: center;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .sign-image {
    width: 60vw; /* Increase size on smaller devices */
  }

  .below-text {
    font-size: 1.2rem; /* Reduce text size on smaller devices */
  }
}

@media (max-width: 480px) {
  .sign-image {
    width: 80vw; /* Even larger width for very small devices */
  }

  .below-text {
    font-size: 1rem; /* Further reduce text size */
  }
}
</style>
